module.exports = __webpack_public_path__ + "static/media/banner_especialista.91582e2c.png";